import { render, staticRenderFns } from "./FormBuilderElementProperties.vue?vue&type=template&id=08829ef8&"
import script from "./FormBuilderElementProperties.vue?vue&type=script&lang=js&"
export * from "./FormBuilderElementProperties.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../Breeze.Kiosk.Frontend/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports